/*
 * KindListeHelpers3.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-10-10 in huWaWi3 33.1.0
 * Copyright (c) 2021, 2023 HUDORA GmbH
 */

import { LadeChecker } from '@hudora/hd-react-components';
import Box from '@mui/material/Box';
import { assertIsString } from 'assertate-debug';
import { useTitle } from 'fluentui-hooks';
import React from 'react';

import { EntityTable3, IEntityTable3Props } from './EntityTable3';

interface KTTheEntityTable3Props extends IEntityTable3Props {
  title: string;
  createPanel: React.ReactElement;
  error: any;
  loading: boolean;
  internalDesignatorLink?: boolean;
}
export const KTTheEntityTable3 = (props: KTTheEntityTable3Props) => {
  assertIsString(props.schemaName, 'schemaName muss gesetzt sein');
  useTitle(props.title);
  return (
    <Box aria-label={'Entity Liste'}>
      {props.createPanel}
      <LadeChecker loading={props.loading} error={props.error} />
      {!props.loading && props.rowData && props.rowData.length < 1 ? (
        <KTEmptyTable3
          createButton={props.createButton}
          error={props.error}
          title={props.title}
        ></KTEmptyTable3>
      ) : (
        <EntityTable3
          {...props}
          rowData={props.rowData}
          hideExcept={props.hideExcept}
          commandBarItems={props.commandBarItems}
          internalDesignatorLink={props.internalDesignatorLink || false}
        />
      )}
    </Box>
  );
};
// Das zeigen wir an, wenn es keine Daten gibt

export const KTEmptyTable3 = (props) => (
  <div>
    {props.title !== '' ? <h2>{props.title}</h2> : null}
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      {props.createButton ? (
        <div
          style={{
            height: '50vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {props.createButton}
        </div>
      ) : props.error ? (
        <>
          Fehler: <pre>{JSON.stringify(props.error, null, 2)}</pre>
        </>
      ) : (
        <>Keine Einträge</>
      )}
    </Box>
  </div>
);
